export class FacturaExportacionFilter {
  emisorId: string;
  fechaDesde: Date;
  fechaHasta: Date;
  razonSocial: string = "";
  folio: string = "";
  estadoSii: string;
  codigoSii: string;
  puerto: string = "";
  pais: string = "";
  clausula: string = "";
  modalidad: string = "";
  importacionMasivaId: string;
  tipoDteId: string = "";
  sucursalId: string;
  reutilizado: number;
  trackId: number;
  ambienteId: number;
}
